/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Fc_Home_Artcraft_CtaInputs */

const en_fc_home_artcraft_cta = /** @type {(inputs: Fc_Home_Artcraft_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`See launcher and installers`)
};

/**
* | output |
* | --- |
* | "See launcher and installers" |
*
* @param {Fc_Home_Artcraft_CtaInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const fc_home_artcraft_cta = /** @type {((inputs?: Fc_Home_Artcraft_CtaInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Fc_Home_Artcraft_CtaInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_fc_home_artcraft_cta(inputs)
});
export { fc_home_artcraft_cta as "fc.home.artcraft.cta" }